<template>
  <div class="public-content platformSku" ref="platformSkuWrapper">
    <div class="breadcrumb">模板</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="searchGroupVo" label-width="130px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="模板名称:">
              <el-input v-model="searchGroupVo.groupName" clearable placeholder="请输入模板名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="模板归属:">
              <el-select v-model="searchGroupVo.groupBelong" clearable placeholder="请选择">
                <el-option label="全部" value="0"></el-option>
                <el-option label="平台" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="模板主题:">
              <el-select v-model="searchGroupVo.templateThemeId" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in templateThemeList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select v-model="searchGroupVo.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="待审核" value="APPLY"></el-option>
                <el-option label="审核拒绝" value="REJECTED"></el-option>
                <el-option label="已审核" value="AUDITED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="模板页性质:">
              <el-select clearable v-model="searchGroupVo.propertyId" placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否关联尺寸组组:">
              <el-select v-model="searchGroupVo.isAssociatedeSizeGroup" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="不关联" value="0"></el-option>
                <el-option label="关联" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="尺寸组名称:">
              <el-input v-model="searchGroupVo.composeSizeGroupName" clearable placeholder="请输入尺寸组名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, onSubmit()" round>查询</el-button>
            <el-button class="search-ok" v-permission="'pts:admin:group:add'" @click="create()" round type="primary">创建模板 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="id" label="编号"></el-table-column>
          <el-table-column prop="groupName" label="模板名称"></el-table-column>
          <el-table-column prop="isAssociatedeSizeGroup" label="是否关联尺寸组">
            <template slot-scope="scope"> {{ +scope.row.isAssociatedeSizeGroup === 0 ? '否' : +scope.row.isAssociatedeSizeGroup === 1 ? '是' : '未定义字段' }} </template>
          </el-table-column>
          <el-table-column prop="composeSizeGroupId" label="尺寸组">
            <template slot-scope="scope">
              <span>{{ scope.row.composeSizeGroupName }}</span>
              <br />
              <span class="color-blue" @click="getSizeGroupMsg(scope.row.composeSizeGroupId), dialogVisible = true">查看尺寸组</span>
            </template>
          </el-table-column>
          <el-table-column prop="propertyName" label="模板性质"></el-table-column>
          <el-table-column prop="payDate" label="模板页数量" v-permission="'pts:admin:group:templatelist'">
            <template slot-scope="scope">
              <p v-for="item in scope.row.templateGroupList" :key="scope.row.id + item.typeName">
                <span @click="toTemplateInfo(scope.row)" class="color-blue">{{ item.typeName + '模板页：' + item.templateGroupNum }}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="imageCount" label="照片数量"></el-table-column>
          <el-table-column prop="groupBelong" label="模版归属" v-permission="'pts:admin:group:storelist'">
            <template slot-scope="scope">
              <span @click="+scope.row.groupBelong === 1 ? $router.push({ path: '/TemGroStore', query: { id: scope.row.id } }) : ''" :class="+scope.row.groupBelong === 1 ? 'color-blue' : ''">{{
                +scope.row.groupBelong === 0 ? '全部' : +scope.row.groupBelong === 1 ? scope.row.storeNumber : '未定义字段' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="themeName" label="模板主题"></el-table-column>
          <el-table-column prop="auditStatus" label="状态">
            <template slot-scope="scope"> {{ scope.row.auditStatus === 'APPLY' ? '待审核' : scope.row.auditStatus === 'AUDITED' ? '已审核' : scope.row.auditStatus === 'REJECTED' ? '已拒绝' : '未定义字段' }}
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建日期"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" v-if="scope.row.auditStatus === 'AUDITED' && $hasPermission('pts:admin:group:update')" @click="edit(scope.row)">编辑<br></span>
              <span class="color-blue" v-if="scope.row.auditStatus === 'APPLY' && $hasPermission('pts:admin:group:audit')" @click="chechExamine(scope.row)">审核<br></span>
              <span class="color-blue" v-if="scope.row.auditStatus === 'REJECTED' && $hasPermission('pts:admin:group:detail')" @click="chechExamine(scope.row, 'check')">查看<br></span>
              <span class="color-blue" v-if="$hasPermission('pts:admin:group:log')" @click="toLog(scope.row)">日志<br></span>
              <span class="color-blue" v-if="$hasPermission('pts:admin:group:batchRemove')" @click="deleteId = scope.row.id, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="尺寸组" :visible.sync="dialogVisible" width="70%">
      <el-table :data="[sizeGroupMsg]" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName">
                  <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                  }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码">
                  <template slot-scope="scope">
                    <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName"></el-table-column>
        <el-table-column label="页面名称" prop="pageName">
          <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除确认 -->
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除该模板？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTemGroup(deleteId)" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { groupGetGroupList, composeGroupDetail, groupBatchRemove, sampleListNoPaging, propertyGetPropertyList } from '@/api/pms'
export default {
  name: 'platform-sku',
  components: {
    VPagination
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.searchGroupVo.createTimeBegin = val[0] + ' 00:00:00'
          this.searchGroupVo.createTimeEnd = val[1] + ' 23:59:59'
        } else {
          this.searchGroupVo.createTimeBegin = ''
          this.searchGroupVo.createTimeEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      deleteId: '',
      deleteDialog: false,
      sizeGroupMsg: {},
      dialogVisible: false,
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      searchGroupVo: {
        auditStatus: '',
        composeSizeGroupId: '',
        createTimeBegin: '',
        createTimeEnd: '',
        groupBelong: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        propertyId: '',
        templateThemeId: '',
        composeSizeGroupName: ''
      },
      propertyList: [],
      tableData: [],
      templateThemeList: [],
      rememberScroll: null
    }
  },
  // // 实例销毁之前调用
  beforeDestroy () {
    // console.log('页面销毁beforeDestroy')
    if (this.rememberScroll) {
      sessionStorage.setItem('offsetY', this.rememberScroll)
    } else {
      sessionStorage.setItem('offsetY', 0)
    }
  },
  async created () {
    // console.log('created')
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.searchGroupVo = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('offsetY')
    }

    if (localStorage.getItem('pageNum')) {
      this.queryInfo.pageNum = localStorage.getItem('pageNum')
    }
    this.$store.dispatch('pms/getPageTypeList')
    await this.onSubmit()
    await this.getFormatList()
    await this.getTemplateThemeList()

    // // 判断页面当前停留位置
    this.$nextTick(() => {
      if (sessionStorage.getItem('offsetY')) {
        this.$refs.platformSkuWrapper.addEventListener('scroll', this.handleScroll)
        // 根据本地缓存取出初始值并渲染页面
        this.rememberScroll = Number(sessionStorage.getItem('offsetY'))
        this.$refs.platformSkuWrapper.scrollTo(0, this.rememberScroll)
      }
    })
  },
  methods: {
    handleScroll (e) { // vue 方法中可直接加e获取event，当@click方法不加括号默认传event参数。      
      const target = e.target // 获取元素目标
      if (target) {
        this.rememberScroll = target.scrollTop// 获取离页面上方高度
        // console.log(this.rememberScroll)
      } else {
        this.rememberScroll = 0
      }
    },
    // 模板页数量
    toTemplateInfo (row) {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchGroupVo))
      this.$router.push({ path: '/checktemplategroup', query: { id: row.id, maxPage: row.templateGroupList } })
    },
    // 创建
    create () {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchGroupVo))
      this.$router.push({ path: '/createtemplategroup' })
    },
    // 编辑
    edit (row) {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchGroupVo))
      this.$router.push({ path: '/edittemplategroup', query: { id: row.id, maxPage: row.templateGroupList } })
    },
    // 查看/审核
    chechExamine (row, type) {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchGroupVo))
      if (type === 'check') {
        this.$router.push({ path: '/audittemplategroup', query: { id: row.id, type: 'check' } })
      } else {
        this.$router.push({ path: '/audittemplategroup', query: { id: row.id, pageNum: this.queryInfo.pageNum } })
      }
    },
    // 日志
    toLog (row) {
      if (this.rememberScroll) {
        sessionStorage.setItem('offsetY', this.rememberScroll)
      } else {
        sessionStorage.setItem('offsetY', 0)
      }
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.searchGroupVo))
      this.$router.push({ path: '/templateGroupLog', query: { id: row.id } })
    },
    // 删除
    deleteTemGroup (id) {
      groupBatchRemove([id]).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.onSubmit()
          this.deleteDialog = false
        }
      })
    },
    // 获取尺寸组详细信息
    getSizeGroupMsg (id) {
      composeGroupDetail(id).then(res => {
        if (res.data.success) {
          this.sizeGroupMsg = res.data.data
        }
      })
    },
    // 获取模板组主题列表
    async getTemplateThemeList () {
      await sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.templateThemeList = res.data.data
        }
      })
    },
    // 获取模板性质列表
    async getFormatList () {
      await propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyList = res.data.data
        }
      })
    },
    async onSubmit () {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.searchGroupVo))
      }
      await groupGetGroupList({ pageSize: this.queryInfo.pageSize, pageNum: this.queryInfo.pageNum, searchGroupVo: { ...this.searchGroupVo, page: this.queryInfo.pageNum } }).then(res => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.onSubmit(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  },
  destroyed () {
    localStorage.removeItem('pageNum')
    sessionStorage.removeItem('searchFlag')
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

.platformSku {
  width: 100%;
  height: 100%;
  // overflow-x: hidden;
  // overflow-y: scroll;
  overflow: scroll;
  // overflow: auto;
  -webkit-overflow-scrolling: touch;
  // &::-webkit-scrollbar {
  //   display: none;
  // }
}
</style>
